import AuthFormWrapper from './AuthFormWrapper';
import {connect, selectors} from '../../../stores'

const mapStateToProps = state => ({
  createRetailer: selectors.auth.selectCreateRetailer(state),
  hasInviteLink: selectors.auth.selectHasInviteLink(state),
});

export default connect(mapStateToProps, null)(AuthFormWrapper);
